export const API_SETMEAL_LIST = '/p/wedding/index.php/Admin/APISetMeal/index'
export const API_HALL_LIST =
  '/p/wedding/index.php/admin/APIHotelMerchant/hallListV2'
export const API_SETMEAL_CATEGORY_ALL =
  '/p/wedding/Admin/APISetMealMerchantCategory/All'

export const API_SETMEAL_CHANGE_ORDER =
  '/p/wedding/index.php/admin/APISetMeal/exchange_order'
